
export enum AssetType {
  Bus= 'Bus',

}